export default function OrganizationFormFields({ data, setData, logoUrl = null }) {
  return (
    <>
      <div className="row g-3">
        <div className="col-md-8">
          <label className="form-label fw-semibold">Navn</label>
          <input
            className="form-control"
            value={data.name}
            onChange={(event) => setData("name", event.target.value)}
            required
          />
        </div>
        <div className="col-md-4">
          <label className="form-label fw-semibold">CVR</label>
          <input
            className="form-control"
            value={data.cvr}
            onChange={(event) => setData("cvr", event.target.value)}
            required
          />
        </div>
      </div>

      <div>
        <label className="form-label fw-semibold">Adresse</label>
        <input
          className="form-control"
          value={data.address}
          onChange={(event) => setData("address", event.target.value)}
          required
        />
      </div>

      <div className="row g-3">
        <div className="col-md-3">
          <label className="form-label fw-semibold">Postnr.</label>
          <input
            className="form-control"
            value={data.zip}
            onChange={(event) => setData("zip", event.target.value)}
            required
          />
        </div>
        <div className="col-md-5">
          <label className="form-label fw-semibold">By</label>
          <input
            className="form-control"
            value={data.city}
            onChange={(event) => setData("city", event.target.value)}
            required
          />
        </div>
        <div className="col-md-4">
          <label className="form-label fw-semibold">Landekode</label>
          <input
            className="form-control"
            value={data.country_code}
            onChange={(event) => setData("country_code", event.target.value.toUpperCase())}
            required
          />
        </div>
      </div>

      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label fw-semibold">Telefon</label>
          <input
            className="form-control"
            value={data.phone}
            onChange={(event) => setData("phone", event.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label fw-semibold">Website</label>
          <input
            className="form-control"
            value={data.website}
            onChange={(event) => setData("website", event.target.value)}
          />
        </div>
      </div>

      <div className="border rounded-3 bg-light-subtle p-3">
        <label className="form-label fw-semibold" htmlFor="organization-logo">Logo på PDF'er</label>
        <p className="small text-muted mb-3">Vises i organisationens dokumenter og PDF-forhåndsvisninger. PNG, JPG, WebP eller SVG, maks. 2 MB.</p>

        {logoUrl && !data.remove_logo ? (
          <div className="d-flex align-items-center gap-3 mb-3">
            <img src={logoUrl} alt="Nuværende organisationslogo" className="border rounded bg-white p-2" style={{ width: "9rem", height: "3.5rem", objectFit: "contain" }} />
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                setData("logo", null);
                setData("remove_logo", true);
              }}
            >
              Fjern logo
            </button>
          </div>
        ) : null}

        {data.remove_logo ? (
          <div className="d-flex align-items-center gap-2 mb-3">
            <span className="small text-muted">Logoet fjernes, når ændringerne gemmes.</span>
            <button type="button" className="btn btn-sm btn-link p-0" onClick={() => setData("remove_logo", false)}>Fortryd</button>
          </div>
        ) : null}

        <input
          id="organization-logo"
          type="file"
          className="form-control"
          accept="image/png,image/jpeg,image/webp,image/svg+xml"
          onChange={(event) => {
            setData("logo", event.target.files?.[0] || null);
            setData("remove_logo", false);
          }}
        />
        {data.logo?.name ? <div className="small text-muted mt-2">Valgt fil: {data.logo.name}</div> : null}
      </div>
    </>
  );
}
